import { QuestionnairesState } from './questionnaires.model';

const questionnairesDefault: QuestionnairesState = {
  data: null,
  pending: false,
  error: undefined,
};

export default questionnairesDefault;
